<nb-card>
	<nb-card-body>
		<form [formGroup]="form">
			<div class="transfer-questions-panel">
				<div class="row-wrapper question">
					<div>
						<label class="question-green"
							   for="transfer-reason-{{product.standard.name.toLowerCase()}}-certificate">{{ 'additional-questions.transfer-questions.transfer-reason' | translate }}</label>
						<textarea class="reason-answer" #transferReason id="transfer-reason-{{product.standard.name.toLowerCase()}}-certificate" nbInput
								  [placeholder]="'common.text-area-placeholder' | translate" fullWidth
								  [formControlName]="fullControlName('transferReason')" [attr.formControlName]="fullControlName('transferReason')"
								  [ngClass]="{'invalid': isInvalid('transferReason')}" (keyup)="autoGrow(transferReason)"></textarea>
						@if (isInvalid('transferReason')) {
							<div class="validation-message">{{ getValidationErrors('transferReason') | async }}</div>
						}
						@if (translationsHelper.translationExists(standardName, 'additionalQuestions.transferReason', false)) {
							<translation-field [standard]="standardName" [previewMode]="!translateClientsData"
											   [translatedText]="translationsHelper.getTranslation(standardName, 'additionalQuestions.transferReason', false)"
											   [translationSubject]="'additionalQuestions.transferReason'"></translation-field>
						}
					</div>
				</div>

				<div class="form-row question">
					<div class="answer-part">
						<nb-radio-group class="radio-group" id="isCurrentCertificationBodyAccredited-{{product.standard.name.toLowerCase()}}-certificate"
										name="isCurrentCertificationBodyAccredited-{{product.standard.name.toLowerCase()}}-certificate"
										[disabled]="shouldDisableRadio('isCurrentCertificationBodyAccredited')"
										[status]="isInvalid('isCurrentCertificationBodyAccredited') ? 'danger' : 'primary'"
										[formControlName]="fullControlName('isCurrentCertificationBodyAccredited')"
										[attr.formControlName]="fullControlName('isCurrentCertificationBodyAccredited')">
							<nb-radio id="is-current-certification-body-accredited-yes-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="true">{{ 'common.yes' | translate }}
							</nb-radio>
							<nb-radio id="is-current-certification-body-accredited-no-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="false">{{ 'common.no' | translate }}
							</nb-radio>
						</nb-radio-group>
					</div>
					<div class="question-part">
						<label class="question-text" for="isCurrentCertificationBodyAccredited-{{product.standard.name.toLowerCase()}}-certificate">
							{{ 'additional-questions.transfer-questions.cb-accredited' | translate }}
						</label>
					</div>
					@if (isInvalid('isCurrentCertificationBodyAccredited')) {
						<div class="validation-message">{{ getValidationErrors('isCurrentCertificationBodyAccredited') | async }}</div>
					}
				</div>

				<div class="form-row question">
					<div class="answer-part">
						<nb-radio-group class="radio-group" id="hasOpenNonConformities-{{product.standard.name.toLowerCase()}}-certificate"
										name="hasOpenNonConformities-{{product.standard.name.toLowerCase()}}-certificate"
										[disabled]="shouldDisableRadio('hasOpenNonConformities')"
										[status]="isInvalid('hasOpenNonConformities') ? 'danger' : 'primary'" [formControlName]="fullControlName('hasOpenNonConformities')"
										[attr.formControlName]="fullControlName('hasOpenNonConformities')"
										(valueChange)="onConfirmitiesChange($event)">
							<nb-radio id="has-open-non-conformities-yes-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
							<nb-radio id="has-open-non-conformities-no-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="false">{{ 'common.no' | translate }}</nb-radio>
						</nb-radio-group>
					</div>
					<div class="question-part">
						<label class="question-text" for="hasOpenNonConformities-{{product.standard.name.toLowerCase()}}-certificate">
							{{ 'additional-questions.transfer-questions.open-non-conformities' | translate }}
						</label>
					</div>
					@if (isInvalid('hasOpenNonConformities')) {
						<div class="validation-message">{{ getValidationErrors('hasOpenNonConformities') | async }}</div>
					}
				</div>

				@if (isOpenNonConformities || product.additionalQuestions.transferQuestions.hasOpenNonConformities) {
					<div class="form-row question corrective-plans">
						<div class="question-with-answer">
							<div class="answer-part">
								<nb-radio-group class="radio-group" id="hasCorrectiveActionPlans-{{product.standard.name.toLowerCase()}}-certificate"
												name="hasCorrectiveActionPlans-{{product.standard.name.toLowerCase()}}-certificate"
												[disabled]="shouldDisableRadio('hasCorrectiveActionPlans')"
												[status]="isInvalid('hasCorrectiveActionPlans') ? 'danger' : 'primary'"
												[formControlName]="fullControlName('hasCorrectiveActionPlans')"
												[attr.formControlName]="fullControlName('hasCorrectiveActionPlans')">
									<nb-radio id="has-corrective-action-plans-yes-{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
									<nb-radio id="has-corrective-action-plans-no--{{product.standard.name.toLowerCase()}}-certificate-radio" [value]="false">{{ 'common.no' | translate }}</nb-radio>
								</nb-radio-group>
							</div>
							<div class="question-part">
								<label class="question-text" for="hasCorrectiveActionPlans-{{product.standard.name.toLowerCase()}}-certificate">
									{{ 'additional-questions.transfer-questions.corrective-action-plans' | translate }} </label>
							</div>
						</div>
						@if (isInvalid('hasCorrectiveActionPlans')) {
							<div class="validation-message">{{ getValidationErrors('hasCorrectiveActionPlans') | async }}</div>
						}
					</div>
					<div class="nc-row">
						<div class="major-nc">
							<label class="question-green" for="major-non-conformities-{{product.standard.name.toLowerCase()}}-certificate">
								{{ 'additional-questions.transfer-questions.major-non-conformities' | translate }}
							</label>
							<div>
								<ng-select id="major-non-conformities-{{product.standard.name.toLowerCase()}}-certificate" class="select-question" [items]="nonConformitiesNumbers"
										   [placeholder]="'common.select' | translate" [multiple]="false" [searchable]="true" [notFoundText]="'common.not-found' | translate"
										   [clearable]="false" [hideSelected]="true" [closeOnSelect]="true" [dropdownPosition]="'auto'"
										   [formControlName]="fullControlName('numberOfMajorNonConformities')" [attr.formControlName]="fullControlName('numberOfMajorNonConformities')">
								</ng-select>
								@if (isInvalid('numberOfMajorNonConformities')) {
									<div class="validation-message">{{ getValidationErrors('numberOfMajorNonConformities') | async }}</div>
								}
							</div>
						</div>
						<div class="minor-nc">
							<label class="question-green" for="minor-non-conformities-{{product.standard.name.toLowerCase()}}-certificate">
								{{ 'additional-questions.transfer-questions.minor-non-conformities' | translate }}
							</label>
							<div>
								<ng-select id="minor-non-conformities-{{product.standard.name.toLowerCase()}}-certificate" class="select-question" [items]="nonConformitiesNumbers"
										   [placeholder]="'common.select' | translate" [multiple]="false" [searchable]="true" [notFoundText]="'common.not-found' | translate"
										   [clearable]="false" [hideSelected]="true" [closeOnSelect]="true" [dropdownPosition]="'auto'"
										   [formControlName]="fullControlName('numberOfMinorNonConformities')" [attr.formControlName]="fullControlName('numberOfMinorNonConformities')">
								</ng-select>
								@if (isInvalid('numberOfMinorNonConformities')) {
									<div class="validation-message">{{ getValidationErrors('numberOfMinorNonConformities') | async }}</div>
								}
							</div>
						</div>
					</div>
				}

				<div class="dates-row">
					<div class="last-audit-date">
						<div class="audit-date-label-flex">
							<label class="question-green">{{ 'additional-questions.transfer-questions.last-audit-performed' | translate }}</label>
						</div>
						<div>
							<date-picker [id]="'last-audit-performed-date_' + product.standard.name" [controlName]="fullControlName('lastAuditPerformedDate')" [formGroup]="form"
										 [value]="lastAuditPerformedDate"
										 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('lastAuditPerformedDate', $event)"
										 [invalidDate]="isInvalid('lastAuditPerformedDate')">
							</date-picker>
							@if (isInvalid('lastAuditPerformedDate')) {
								<div class="validation-message">{{ getValidationErrors('lastAuditPerformedDate') | async }}</div>
							}
						</div>
					</div>
					<div class="expiration-date">
						<div class="audit-date-label-flex">
							<label class="question-green">{{ 'additional-questions.transfer-questions.cert-exp-date' | translate }}</label>
						</div>
						<div>
							<date-picker [id]="'expiration-date_' + product.standard.name" [controlName]="fullControlName('expirationDate')" [formGroup]="form" [value]="expirationDate"
										 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('expirationDate', $event)"
										 [invalidDate]="isInvalid('expirationDate')">
							</date-picker>
							@if (isInvalid('expirationDate')) {
								<div class="validation-message">{{ getValidationErrors('expirationDate') | async }}</div>
							}
							@if (expirationDateIsInPastOrClose) {
								<div class="validation-message">
									{{ 'additional-questions.transfer-questions.expiration-date-msg' | translate }}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</form>
	</nb-card-body>
</nb-card>
